// extracted by mini-css-extract-plugin
module.exports = {"paymentImg":"modalContents-styles_paymentImg__o7Cg1","sampleMargin":"modalContents-styles_sampleMargin__1hiLk"};